import { breadcrumbConfig } from '../breadcrumb-config';

export function findDynamicRouteMatch(path: string): string | null {
  for (const [pattern, label] of Object.entries(breadcrumbConfig)) {
    if (!pattern.includes('[')) {
      continue;
    }

    const patternParts = pattern.split('/');
    const pathParts = path.split('/');

    if (patternParts.length !== pathParts.length) {
      continue;
    }

    const isMatch = patternParts.every(
      (part, index) => part.startsWith('[') || part === pathParts[index],
    );

    if (isMatch) {
      return label;
    }
  }

  return null;
}
